import React from "react";
import { useProductsStore } from "../../stores/productsStore";
import { formatProcent } from "utils/format";

// Компонент відображення статистики сторінки "Товари постачальників"
const ProductsSummaryPanel = () => {
  // Отримуємо дані та дії безпосередньо зі стору
  const suppliers = useProductsStore((state) => state.suppliers);
  const totalCount = useProductsStore((state) => state.totalCount);
  const counts = useProductsStore((state) => state.counts);

  // Розраховуємо статистику
  const totalSuppliers = suppliers.length;
  const { available, order, notAvailable } = counts;

  return (
    <ul className="summary-panel">
      <li>
        <span className="label">Постачальників:</span>
        <strong className="value">{totalSuppliers}</strong>
      </li>
      <li>
        <span className="label">Товарів (всіх):</span>
        <strong className="value">{totalCount}</strong>
      </li>
      <li className="available-status">
        <span className="label">Наявні:</span>
        <strong className="value">{available}</strong>
        <span className="percentage">({formatProcent(available / totalCount)})</span>
      </li>
      <li className="order-status">
        <span className="label">Замовити:</span>
        <strong className="value">{order}</strong>
        <span className="percentage">({formatProcent(order / totalCount)})</span>
      </li>
      <li className="not-available-status">
        <span className="label">Не наявні:</span>
        <strong className="value">{notAvailable}</strong>
        <span className="percentage">({formatProcent(notAvailable / totalCount)})</span>
      </li>
    </ul>
  );
};

export default ProductsSummaryPanel;
